import type { AnomalyKind, AnomalyRow } from '../api/hr-anomalies';

/**
 * 이상 근태의 말과 셈 — **화면과 검사가 같은 것을 쓴다**(문구가 두 벌이 되지 않게).
 */
export const ANOMALY_LABEL: Record<AnomalyKind, string> = {
  MISSING_CHECKOUT: '퇴근 누락',
  ABSENT: '미출근',
};

/** 왼쪽 띠 색을 고르는 이름. 퇴근 누락이 더 무겁다 — 지난 일이고 사람이 마감해야 한다. */
export const ANOMALY_TONE: Record<AnomalyKind, 'bad' | 'warn'> = {
  MISSING_CHECKOUT: 'bad',
  ABSENT: 'warn',
};

export type AnomalyFilter = 'ALL' | AnomalyKind;

/**
 * 걸러 보기 — **숫자와 목록이 따로 놀지 않게** 칩이 곧 필터다.
 * ★ 「전부」는 그대로 준다(복사본이라 부르는 쪽이 정렬해도 원본이 안 흔들린다).
 */
export function filterAnomalies(rows: readonly AnomalyRow[], f: AnomalyFilter): AnomalyRow[] {
  return f === 'ALL' ? [...rows] : rows.filter((r) => r.kind === f);
}

/** 소속 한 줄 — 부서와 팀이 다 없을 수도 있다(미배정). */
export function orgText(row: Pick<AnomalyRow, 'divisionName' | 'teamName'>): string {
  return [row.divisionName, row.teamName].filter(Boolean).join(' · ') || '소속 없음';
}
